export enum VoteSubmissionType {
  VOTER = 'VOTER',
  ADMIN = 'ADMIN',
}

export enum VotingType {
  DECISION = 'DECISION',
  ELECTION = 'ELECTION',
  ALTERNATIVE_OPTIONS = 'ALTERNATIVE_OPTIONS',
}

export interface DecisionVote {
  _id?: string;
  meeting: string;
  agendaItemId: string;
  voterEntity: string;
  submitterUser: string;
  submissionType: VoteSubmissionType;
  timestamp: string;
  decisionVoteOption: DecisionVoteOption;
  submitterRolesAtTime?: string[];
  agendaItemTitleAtTime?: string;
  withdrawVote?: boolean;
}

export interface ElectionVote {
  _id?: string;
  voterEntity: string;
  agendaItemId: string;
  electionBallot?: string[];
  submitterUser: string;
  submissionType: VoteSubmissionType;
  timestamp: string;
  meeting: string;
  submitterRolesAtTime?: string[];
  agendaItemTitleAtTime?: string;
  withdrawVote?: boolean;
}

export interface ElectionCandidate {
  _id?: string;
  name: string;
  userId?: string;
  value?: any;
}

export enum DecisionVoteOption {
  FOR = 'FOR',
  AGAINST = 'AGAINST',
  NEUTRAL = 'NEUTRAL',
  WITHDRAW_VOTE = 'WITHDRAW_VOTE',
}

export enum VotingChangeType {
  BULK_VOTES_SUBMISSION = 'BULK_VOTES_SUBMISSION',
  ELECTION_CANDIDATES_DATA = 'ELECTION_CANDIDATES_DATA',
  VOTING_LOCK = 'VOTING_LOCK',
  GA_MAJORITY_REQUIREMENT_RULE = 'GA_MAJORITY_REQUIREMENT_RULE',
  VOTES_VISIBLE_TO_ALL = 'VOTES_VISIBLE_TO_ALL',
}

export enum GAMajorityRequirementRule {
  ORDINARY_MAJORITY = 'ORDINARY_MAJORITY', // ref aksjeloven 5-17
  STATUTORY_CHANGE = 'STATUTORY_CHANGE', // ref aksjeloven 5-18
  QUALIFIED_MAJORITY = 'QUALIFIED_MAJORITY', // ref aksjeloven 5-19
  UNANIMITY = 'UNANIMITY', // ref aksjeloven 5-20
  INVESTIGATION_PROPOSITION = 'INVESTIGATION_PROPOSITION', // ref aksjeloven 5-25
}
